import React from 'react'

const UploadToArchive = ({ store }) => {
  return (<p><br />
    <strong>Description:</strong>
    <ul>
      <li>This module moves encoded film uploads (files) to the archive</li>
      <li>Features/preview only</li>
      <li>Each upload (file) can be restored later</li>
    </ul>
    <br />
  </p>)
}
export default UploadToArchive
